module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('app-toolbar'), _vm._v(" "), _c('v-main', {
    staticClass: "full-height",
    class: {
      'v-main--with-toolbar': _vm.mainWithToolbarOffset
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('g-snackbar', {
    ref: "snack"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42923dee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1704
// module chunks = 2